const translation: Record<string, string> = {
  "site.name": "Itaobuy Spreadsheet",
  "site.tagline": "La guida italiana completa",
  "nav.home": "Home",
  "nav.guida": "Guida",
  "nav.recensioni": "Recensioni",
  "nav.sicurezza": "Sicurezza",
  "nav.confronti": "Confronti",
  "nav.guidaAcquisti": "Guida Acquisti",
  "nav.categorie": "Categorie Prodotto",
  "nav.buyNow": "Buy It Now",
  "hero.title": "La guida italiana completa per Itaobuy Spreadsheet",
  "hero.subtitle": "Scopri tutto quello che devi sapere su Itaobuy Spreadsheet",
  "hero.cta1": "Itaobuy Sheet",
  "hero.cta2": "Buy It Now",
  "footer.newsletter": "Resta aggiornato sulle novità di Itaobuy Spreadsheet",
  "footer.rights": "Tutti i diritti riservati",
};

export default translation;